// externals
import React from 'react';
import { ArrowSmallDownIcon } from '@interstate/components/Icons/ArrowSmallDownIcon';
import { ArrowSmallUpIcon } from '@interstate/components/Icons/ArrowSmallUpIcon';

type RollToProfitIndicatorProps = {
    currentValue?: number | string | undefined;
    previousValue?: number | string | undefined;
    showIndicator?: boolean;
};
import { indicatorContainerStyle } from '../RollToStyles';

const RollToProfitIndicator: React.FC<RollToProfitIndicatorProps> = ({ currentValue, previousValue, showIndicator }) => {
    return (
        <span data-testid="roll-to-profit-indicator" style={indicatorContainerStyle}>
            {previousValue !== undefined && currentValue !== undefined && showIndicator ? (
                currentValue < previousValue ? (
                    <ArrowSmallDownIcon data-testid="arrow-down" style={{ color: 'red', position: 'relative' }} />
                ) : currentValue > previousValue ? (
                    <ArrowSmallUpIcon data-testid="arrow-up" style={{ color: 'green', position: 'relative' }} />
                ) : null
            ) : null}
        </span>
    );
};

export default RollToProfitIndicator;
